<header id="header">
  <div class="content-wrapper header-wrapper">
    <button class="no-style-button header-button-home" aria-label="PRO MEBLE — strona główna" type="button" (click)="navigateToHomePage()">
      <img [ngSrc]="'/assets/images/pro-meble-logo.png'" [width]="160" [height]="40" fetchpriority="high" alt="PRO MEBLE Logo" />
    </button>

    <nav class="header-nav" aria-label="Nawigacja">
      <a [routerLink]="'/realizacje'" class="mp-btn tw-discreet header-link-portfolio">Realizacje</a>
      <a [routerLink]="'/proces'" class="mp-btn tw-discreet header-link-process">Proces</a>
      <a [routerLink]="'/faq'" class="mp-btn tw-discreet header-link-faq">FAQ</a>
      <a [routerLink]="'/kontakt'" class="mp-btn tw-discreet header-link-contact">Kontakt</a>
    </nav>

    <div class="header-cta">
      <app-cta-button [text]="'Bezpłatna wycena'" [small]="true" [additionalButtonClass]="'header-button-quote'"></app-cta-button>
    </div>
  </div>
</header>
